import React from "react";
import { FormattedMessage } from "react-intl";

import * as notesServiceApi from "../api/notesServiceApi";
import { notify, notifyError } from "../actions/notificationsActions";
import * as types from "../constants/ActionTypes";
import { PUBLIC_URL } from "../constants/Env";

export const fetchAllSecureNotes = () => dispatch => {
  return notesServiceApi
    .fetchAllSecureNotes()
    .then(response => {
      dispatch({
        type: types.FETCH_ALL_SECURE_NOTES_RECEIVED,
        notes: response.notes
      });
    })
    .catch(error => {
      if (error.message === "Forbidden") {
        dispatch({
          type: types.SECURE_NOTES_DISABLED
        });
      } else {
        dispatch(
          notifyError({
            message: (
              <FormattedMessage
                defaultMessage="We couldn't load your secure notes"
                id="fetchAllSecureNotesFailure"
              />
            )
          })
        );
      }
    });
};

export const fetchCurrentNote = id => dispatch => {
  return notesServiceApi
    .fetchCurrentNote(id)
    .then(response => {
      dispatch({
        type: types.FETCH_CURRENT_NOTE_RECEIVED,
        note: response.note
      });
    })
    .catch(error => {
      if (error.message === "Forbidden") {
        dispatch({
          type: types.SECURE_NOTES_DISABLED
        });
      } else {
        dispatch(
          notifyError({
            message: (
              <FormattedMessage
                defaultMessage="We couldn't open your current note"
                id="fetchCurrentNoteFailure"
              />
            )
          })
        );
        dispatch(setScreenToNotesList());
      }
    });
};

export const submitNewNote = ({ title, content, history }) => dispatch => {
  return notesServiceApi
    .submitNewNote({ title, content })
    .then(response => {
      dispatch({
        type: types.FETCH_CURRENT_NOTE_RECEIVED,
        note: response.note
      });
      dispatch(fetchAllSecureNotes());
      history.push(`${PUBLIC_URL}/${response.note.id}`);
      dispatch(setScreenToShowNote());
      dispatch(
        notify({
          message: (
            <FormattedMessage
              defaultMessage="You have successfully created a new note"
              id="submitNewNoteSuccess"
            />
          ),
          type: "success"
        })
      );
    })
    .catch(error => {
      if (error.message === "Forbidden") {
        dispatch({
          type: types.SECURE_NOTES_DISABLED
        });
      } else {
        dispatch(
          notifyError({
            message: (
              <FormattedMessage
                defaultMessage="Failed to create a new note"
                id="submitNewNoteFailure"
              />
            )
          })
        );
      }
    });
};

export const updateCurrentNote = ({ id, title, content }) => dispatch => {
  return notesServiceApi
    .updateCurrentNote({ id, title, content })
    .then(response => {
      dispatch({
        type: types.FETCH_CURRENT_NOTE_RECEIVED,
        note: response.note
      });
      dispatch(fetchAllSecureNotes());
      dispatch(
        notify({
          message: (
            <FormattedMessage
              defaultMessage="You have successfully updated the note"
              id="updateNoteSuccess"
            />
          ),
          type: "success"
        })
      );
    })
    .catch(error => {
      if (error.message === "Forbidden") {
        dispatch({
          type: types.SECURE_NOTES_DISABLED
        });
      } else {
        dispatch(
          notifyError({
            message: (
              <FormattedMessage
                defaultMessage="Failed to update the note"
                id="updateNoteFailure"
              />
            )
          })
        );
      }
    });
};

export const deleteCurrentNote = id => dispatch => {
  return notesServiceApi
    .deleteCurrentNote(id)
    .then(() => {
      dispatch(fetchAllSecureNotes());
      dispatch(setScreenToNotesList());
      dispatch(
        notify({
          message: (
            <FormattedMessage
              defaultMessage="You have successfully deleted the note"
              id="deleteNoteSuccess"
            />
          ),
          type: "success"
        })
      );
    })
    .catch(error => {
      if (error.message === "Forbidden") {
        dispatch({
          type: types.SECURE_NOTES_DISABLED
        });
      } else {
        dispatch(
          notifyError({
            message: (
              <FormattedMessage
                defaultMessage="Failed to delete the note"
                id="deleteNoteFailure"
              />
            )
          })
        );
      }
    });
};

export const showAssumedUserFailure = notifyError({
  message: (
    <FormattedMessage
      defaultMessage="You cannot view assumed users' notes"
      id="assumedUserFailure"
    />
  )
});

export const setScreenToNewNote = () => dispatch => {
  dispatch({
    type: types.SET_SCREEN_TO_NEW_NOTE
  });
};

export const setScreenToShowNote = () => dispatch => {
  dispatch({
    type: types.SET_SCREEN_TO_SHOW_NOTE
  });
};

export const setScreenToNotesList = () => dispatch => {
  dispatch({
    type: types.SET_SCREEN_TO_NOTES_LIST
  });
};

export const clearNotesError = () => dispatch => {
  dispatch({
    type: types.CLEAR_NOTES_ERROR
  });
};
